import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import {
  changeClosingFilterConciliationDetailErrors,
  reportFilterConciliationDetailErrorsSelector,
  ConciliationDetailErrorsTypesSelector,
  activeConciliationRulesSelector,
} from '../../../state';
import { MultiSelect } from '../../selects';
import { ConciliationDetailErrors } from '../../../types';

const ErrorFilter = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const errorsOptions = useSelector(ConciliationDetailErrorsTypesSelector);
  const errorsSelected = useSelector(reportFilterConciliationDetailErrorsSelector);
  const activeRules = useSelector(activeConciliationRulesSelector);

  const allOptions = errorsOptions.data?.errors || [];

  const validErrorValues = new Set<string>(Object.values(ConciliationDetailErrors));

  const options =
    activeRules.length > 0
      ? Array.from(
          new Set(
            activeRules
              .map(rule => rule.code)
              .filter((code): code is ConciliationDetailErrors => validErrorValues.has(code))
          )
        )
      : allOptions;

  const handleChange = useCallback(
    (value: ConciliationDetailErrors[]) =>
      dispatch(changeClosingFilterConciliationDetailErrors(value)),
    [dispatch]
  );

  return (
    <MultiSelect<ConciliationDetailErrors>
      label={t('toolbar.labels.error')}
      options={options}
      translationKey="conciliation-detail.error-types"
      value={errorsSelected}
      onChange={handleChange}
      loading={errorsOptions.loading}
      selectAll
    />
  );
};

export default ErrorFilter;
